import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { homeService } from '../../../../../../../../shared/src/api';

export const useHomeIcons = () => {
  return useSuspenseQuery({
    queryKey: queryKey.homeIcons(),
    queryFn: () => homeService.getHomeIcons(),
  });
};
